module.exports = __webpack_public_path__ + "e51ebdeef3ba04db4dfaa432d6132a5d.png";